import React from 'react';
import Select from 'react-select';

const Filters = React.memo(
    ({
        accountOptions,
        categoryOptions,
        selectedType,
        setSelectedType,
        selectedAccount,
        setSelectedAccount,
        selectedCategory,
        setSelectedCategory,
        resetFilters,
        t,
    }) => (
        <div className="row gx-2 gy-2">
            <div className="col-6 col-sm-6">
                <select
                    className="form-select filter-select"
                    value={selectedType}
                    onChange={(e) => setSelectedType(e.target.value)}
                >
                    <option value="">{t('allTypes')}</option>
                    <option value="income">{t('income')}</option>
                    <option value="expense">{t('expense')}</option>
                    <option value="transfer">{t('transfer')}</option>
                    <option value="withdraw">{t('withdraw')}</option>
                </select>
            </div>
            <div className="col-6 col-sm-6">
                <Select
                    menuPortalTarget={document.body}
                    options={accountOptions}
                    value={accountOptions.find((opt) => opt.value === selectedAccount)}
                    onChange={(opt) => setSelectedAccount(opt.value)}
                    isSearchable
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 11 }) }}
                    placeholder={t('allWallets')}
                />
            </div>
            <div className="col-6 col-sm-6">
                <Select
                    menuPortalTarget={document.body}
                    options={categoryOptions}
                    value={categoryOptions.find((opt) => {
                        // Handle empty string case explicitly
                        if (selectedCategory === '') {
                            return opt.value === '';
                        }
                        // For numeric values, compare as numbers
                        const optValue = isNaN(opt.value) ? opt.value : parseInt(opt.value, 10);
                        const selValue = isNaN(selectedCategory)
                            ? selectedCategory
                            : parseInt(selectedCategory, 10);
                        return optValue === selValue;
                    })}
                    onChange={(opt) => setSelectedCategory(opt.value)}
                    isSearchable
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 11 }) }}
                    placeholder={t('allCategories')}
                />
            </div>
            <div className="col-6 col-sm-6">
                <button
                    className="btn btn-outline-secondary w-100 reset-button"
                    onClick={resetFilters}
                >
                    {t('resetFilters')}
                </button>
            </div>
        </div>
    )
);

export default Filters;
